import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import StrategyAutomationPage from './pages/StrategyAutomationPage';
import ServicePage from './pages/ServicePage';
import LegalPage from './pages/Legal';
import Portal from './pages/Portal';
import PortalDemo from './pages/Portaldemo';
import QTraderResultsPage from './pages/Qtraderresultspage';
import './index.css';

// ─────────────────────────────────────────────────────────────────────────────
// Google Apps Script web app from the Agency OS workbook (see the Setup tab). When set, every enquiry goes to the Leads sheet.
const LEADS_URL = process.env.REACT_APP_LEADS_URL || 'https://script.google.com/macros/s/AKfycby51VGDIglXC8pPDyX_95jqRnKUHfN0zpRPP-I_6QxzpYwmMM6UZifHihj3v7R7UWg/exec';
const API = process.env.REACT_APP_API_URL || 'https://qire-license-api-production.up.railway.app';

export default function App() {

  const addLead = async (lead) => {
    const subject = lead.subject || '';

    if (LEADS_URL) {
      try {
        // text/plain keeps this a "simple" request, so the browser skips the CORS preflight that Apps Script cannot answer
        await fetch(LEADS_URL, {
          method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            type: lead.type || 'lead', name: lead.name, firstName: lead.firstName || '', lastName: lead.lastName || '', email: lead.email, phone: lead.phone || '',
            service: lead.service || '', role: lead.role || '', platform: lead.platform || '', budget: lead.budget || '', timeline: lead.timeline || '', sharing: lead.sharing || '', reply: lead.reply || '',
            subject, message: lead.message || '', source: lead.source || 'Website', form: lead.form || '', utm: lead.utm || '', page: window.location.pathname,
          }),
        });
      } catch (err) {
        console.warn('Lead submission failed (offline?):', err.message);
      }
      return;
    }

    let product = 'Other';
    if      (subject.includes('TradesPlus'))        product = 'TradesPlus';
    else if (subject.includes('ArbitragePlus'))      product = 'ArbitragePlus';
    else if (subject.includes('Q-Trader'))           product = 'Q-Trader EA';
    else if (subject.includes('SheetsInsider'))      product = 'SheetsInsider';
    else if (subject.includes('Custom Trading'))     product = 'Custom Trading';
    else if (subject.includes('Partnership'))        product = 'Partnership';
    else if (subject.includes('QireOS'))             product = 'QireOS';
    else if (subject.includes('Agency OS'))          product = 'QireOS';
    else if (subject.includes('IT Support'))         product = 'IT Support';
    else if (subject.includes('Remote Technical'))   product = 'IT Support';

    const isWaitlist = lead.type === 'waitlist';
    const endpoint   = isWaitlist ? '/api/v1/waitlist' : '/api/v1/leads';
    const payload = isWaitlist
      ? { name: lead.name, email: lead.email, product, source: lead.source || 'Landing Page', notes: lead.message || '' }
      : { name: lead.name, email: lead.email, product, source: lead.source || 'Landing Page', message: `[${subject}]\nPhone: ${lead.phone || ''}\n${lead.message || ''}`, status: 'NEW', budget: 0, currency: 'USD' };

    try {
      await fetch(`${API}${endpoint}`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(payload),
      });
    } catch (err) {
      console.warn('Lead submission failed (offline?):', err.message);
    }
  };

  return (
    <Routes>
      <Route path="/"              element={<LandingPage onSubmitLead={addLead} />} />
      <Route path="/strategy-automation" element={<StrategyAutomationPage onSubmitLead={addLead} />} />
      <Route path="/services/:slug" element={<ServicePage onSubmitLead={addLead} />} />
      <Route path="/EA"            element={<Navigate to="/strategy-automation" replace />} />
      <Route path="/privacy"       element={<LegalPage />} />
      <Route path="/terms"         element={<LegalPage />} />
      <Route path="/disclaimer"    element={<LegalPage />} />
      <Route path="/portal"        element={<Portal />} />
      <Route path="/portal/*"      element={<Portal />} />
      <Route path="/portal-demo"     element={<PortalDemo />} />
      <Route path="/portal-demo/*"   element={<PortalDemo />} />
      <Route path="/strategy-tester" element={<QTraderResultsPage />} />
    </Routes>
  );
}